// Helpers shared by every view that renders ActivityLog rows (the Activity page and the
// dashboard's Recent Activity panel), so they agree on how a row is labelled and, more
// importantly, never leak the structured payload into human-facing text.

// An "Assessment Shared" entry appends a JSON payload after this marker (see
// AssessmentService.ShareMetaMarker). Everything before it is prose meant for people.
export const SHARE_META_MARKER = '##share-meta##';

// Strip the structured payload off a Details string. Always run this before showing
// `activity.details` anywhere, or share rows render a wall of raw JSON.
export const stripShareMeta = (details) => {
  if (!details) return '';
  const at = details.indexOf(SHARE_META_MARKER);
  return (at === -1 ? details : details.slice(0, at)).trim();
};

// Badge colours keyed off the action verb, so the same action reads the same everywhere.
export const getActionBadgeColor = (action) => {
  const actionLower = (action || '').toLowerCase();
  if (actionLower.includes('created')) return 'bg-emerald-100 text-emerald-700';
  if (actionLower.includes('updated')) return 'bg-blue-100 text-blue-700';
  if (actionLower.includes('deleted')) return 'bg-red-100 text-red-700';
  if (actionLower.includes('shared')) return 'bg-indigo-100 text-indigo-700';
  if (actionLower.includes('alert') || actionLower.includes('failed')) return 'bg-red-100 text-red-700';
  if (actionLower.includes('pending') || actionLower.includes('review')) return 'bg-amber-100 text-amber-700';
  return 'bg-slate-100 text-slate-700';
};
